import {Box, CircularProgress, styled} from '@mui/material';

const Overlay = styled(Box)(() => ({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0,0,0,.5)',
  zIndex: 2,
}));

interface Props {
  loading?: boolean;
}

export const Spinner = ({loading}: Props) => {
  if (!loading) return null;
  return (
    <Overlay>
      <CircularProgress />
    </Overlay>
  );
};
